module.exports = __webpack_public_path__ + "static/media/picture.b0ca4036.jpg";